var GOOGLE_MAP_API_KEY = 'AIzaSyCOVMLxGVd2OdL5jf5vW1XjwL_KwmdCm_o';

export { GOOGLE_MAP_API_KEY };
//# sourceMappingURL=config.js.map
